var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
let InlineEditLabel = class InlineEditLabel extends Vue {
    constructor() {
        super(...arguments);
        this.editing = false;
        this.text = "";
    }
    confirmEdit() {
        this.editing = false;
        return this.text;
    }
    startEdit() { this.editing = true; }
    cancelEdit() {
        this.editing = false;
        this.text = this.textData;
    }
    get submittable() { return this.text !== ""; }
    created() { this.text = this.textData; }
    onTextChanged(val) { this.text = val; }
};
__decorate([
    Prop({ required: true })
], InlineEditLabel.prototype, "textData", void 0);
__decorate([
    Prop({ required: true })
], InlineEditLabel.prototype, "disabled", void 0);
__decorate([
    Inject()
], InlineEditLabel.prototype, "i18n", void 0);
__decorate([
    Emit("update-text")
], InlineEditLabel.prototype, "confirmEdit", null);
__decorate([
    Watch("textData")
], InlineEditLabel.prototype, "onTextChanged", null);
InlineEditLabel = __decorate([
    Component({
        name: "InlineEditLabel",
    })
], InlineEditLabel);
export default InlineEditLabel;
